import * as React from 'react';

import { SorterResult } from 'antd/lib/table/interface';

import { SortingDirection } from '@common/react/components/Pages/ItemsPage';
import { TableRemoteSorterData } from '@common/react/smart components/Table/TableRemoteSorter';
import { WithId } from '@common/typescript/objects/WithId';

type Sorter<T> = Omit<SorterResult<T>, 'caption'> & { caption: string }
export function useTableRemoteSorter<T extends WithId>(): TableRemoteSorterData<T> {
	const [sorter, setSorter] = React.useState<Sorter<T> | undefined>(undefined);

	return React.useMemo(() => ({
		sorter: {
			column: sorter?.column ? [{
				caption: sorter.field,
				direction: sorter.order === 'descend'
					? SortingDirection.Descending
					: SortingDirection.Ascending,
			}] : [],
		},
		setSorter,
	}), [sorter]) as TableRemoteSorterData<T>;
}
